<div class="content-wrapper container-xxl p-0">
  <div class="content-body">
    <app-content-header [contentHeader]="contentHeader"></app-content-header>
    <div class="card">
      <div class="card-title pt-2 pb-0 px-2 row">
        <div class="col-xl-3 col-12" [ngClass.sm]="'mb-1'" [ngClass.md]="'mb-1'">
          <input type="search" [(ngModel)]="filterSearch" (ngModelChange)="filter()" class="form-control" [placeholder]="'SEARCH_COMMISSION_NAME' | translate" />
        </div>
        <div class="col-xl-2 col-12 fix-ng-select-clear" [ngClass.sm]="'mb-1'" [ngClass.md]="'mb-1'">
          <ng-select [(ngModel)]="filterCustomer" [closeOnSelect]="true" [openOnEnter]="true" [virtualScroll]="true" [clearable]="filterCustomer > 0" (clear)="filterCustomer = 0" (ngModelChange)="filter()">
            <ng-option [value]="0">
              <span class="font-small-4 font-weight-normal pr-2">{{ "CUSTOMER" | translate }}</span>
            </ng-option>
            <ng-option *ngFor="let customer of customersList" [value]="customer.id">
              <span class="font-small-4 font-weight-normal pr-2">{{ customer.name }}</span>
            </ng-option>
          </ng-select>
        </div>
        <div class="col-xl-3 col-12 d-flex fix-ng-select-clear">
          <ng-select class="flex-basis-50" [(ngModel)]="filterMonth" [closeOnSelect]="true" [openOnEnter]="true" [virtualScroll]="true" [clearable]="filterMonth>0" (clear)="filterMonth = 0" (ngModelChange)="filter()">
            <ng-option [value]="0"><span class="font-small-4 font-weight-normal pr-2">{{ "MONTH" | translate | titlecase }}</span></ng-option>
            <ng-option *ngFor="let month of availableMonths" [value]="month"><span class="font-small-4 font-weight-normal pr-2">{{ "2023-" + month + "-01" | date: "MMMM" : "" : "it-IT" | titlecase }}</span></ng-option>
          </ng-select>
          <ng-select class="flex-basis-50 d-block ml-2" [closeOnSelect]="true" [openOnEnter]="true" [virtualScroll]="true" [clearable]="false" [(ngModel)]="filterYear" (change)="filter()">
            <ng-option [value]="0"><span class="font-small-4 font-weight-normal pr-2">{{ "YEAR" | translate | titlecase }}</span></ng-option>
            <ng-option *ngFor="let year of availableYears" [value]="year"><span class="font-small-4 font-weight-normal pr-2">{{ year }}</span></ng-option>
          </ng-select>
        </div>
        <div class="col-xl-4 text-right d-flex justify-content-end">
          <app-select-table-limit [defaultValue]="tableLimit" (onChange)="tableLimit = $event"></app-select-table-limit>
        </div>
        <div class="col-xl-3 mt-1">
          <ng-select [(ngModel)]="filter_detachment" [searchable]="false" [closeOnSelect]="true" [openOnEnter]="true" [virtualScroll]="true" [clearable]="false" (ngModelChange)="filter()">
            <ng-template ng-label-tmp let-item="item">
              <span class="font-small-4 font-weight-normal pr-2" *ngIf="item===1">{{ "DETACHMENT_FILTER" | translate }}: {{ "DELTA" | translate }}</span>
              <span class="font-small-4 font-weight-normal pr-2" *ngIf="item===2">{{ "DETACHMENT_FILTER" | translate }}: {{ "DETACHMENT" | translate }}</span>
              <span class="font-small-4 font-weight-normal pr-2" *ngIf="item===0">{{ "DETACHMENT_FILTER" | translate }}: {{ "NO" | translate }} </span>
            </ng-template>
            <ng-option [value]="0">
              <span class="font-small-4 font-weight-normal pr-2">{{ "NO" | translate }}</span>
            </ng-option>
            <ng-option [value]="1">
              <span class="font-small-4 font-weight-normal pr-2">{{ "DELTA" | translate }}</span>
            </ng-option>
            <ng-option [value]="2">
              <span class="font-small-4 font-weight-normal pr-2">{{ "DETACHMENT" | translate }}</span>
            </ng-option>
          </ng-select>
        </div>
        <div class="col-xl-3 mt-1">
          <ng-select [(ngModel)]="filter_type_order" [closeOnSelect]="true" [searchable]="false" [openOnEnter]="true" [virtualScroll]="true" [clearable]="false" (ngModelChange)="filter()">
            <ng-template ng-label-tmp let-item="item">
              <span class="font-small-4 font-weight-normal pr-2" *ngIf="item===0">{{ "ORDER_TYPE" | translate }}: {{ "TIME_MATERIAL" | translate }} </span>
              <span class="font-small-4 font-weight-normal pr-2" *ngIf="item===1">{{ "ORDER_TYPE" | translate }}: {{ "TASK" | translate }} </span>
              <span class="font-small-4 font-weight-normal pr-2" *ngIf="item===2">{{ "ORDER_TYPE" | translate }}: {{ "PRODUCTS" | translate }} </span>
              <span class="font-small-4 font-weight-normal pr-2" *ngIf="item===-1">{{ "TYPE_ORDER_FILTER" | translate }} </span>
            </ng-template>
            <ng-option [value]="-1">
              <span class="font-small-4 font-weight-normal pr-2">{{ "ALL" | translate }}</span>
            </ng-option>
            <ng-option [value]="0">
              <span class="font-small-4 font-weight-normal pr-2">{{ "TIME_MATERIAL" | translate }}</span>
            </ng-option>
            <ng-option [value]="1">
              <span class="font-small-4 font-weight-normal pr-2">{{ "TASK" | translate }}</span>
            </ng-option>
            <ng-option [value]="2">
              <span class="font-small-4 font-weight-normal pr-2">{{ "PRODUCTS" | translate }}</span>
            </ng-option>
          </ng-select>
        </div>
      </div>

      <div class="card-body p-0">
        <ngx-datatable
          class="bootstrap core-bootstrap"
          columnMode="force" #table
          [headerHeight]="30"
          [scrollbarH]="true"
          [rows]="filteredInvoices"
          [rowHeight]="50"
          [limit]="tableLimit"
          [footerHeight]="50"
          [messages]="{ emptyMessage: ('NO_DATA_TO_DISPLAY' | translate) }"
          [sorts]="[
            { prop: 'can_generate', dir: 'desc'},
            { prop: 'month', dir: 'asc' },
            { prop: 'year', dir: 'asc' },
            { prop: 'commission.protocol', dir: 'asc' }
          ]"
        >
          <ngx-datatable-column [name]="'COMMISSION' | translate" prop="commission_name" width="350" [sortable]="true">
            <ng-template ngx-datatable-cell-template let-row="row">
              <div class="d-flex align-items-center">
                <a target="_blank" *ngIf="!row.products?.length" [routerLink]="'/dashboard/commission/edit/' + row.commission.id">{{ row.commission_name }}</a>
                <a target="_blank" *ngIf="row.products?.length" [routerLink]="'/dashboard/commissions/edit-product-commission/' + row.commission.id">{{ row.commission_name }}</a>
              </div>
            </ng-template>
          </ngx-datatable-column>
          <ngx-datatable-column [name]="'DATE' | translate" prop="date" width="80" [sortable]="true">
            <ng-template ngx-datatable-cell-template let-row="row"> {{ row.month_name | titlecase }} {{ row.year }}</ng-template>
          </ngx-datatable-column>
          <ngx-datatable-column [name]="'BILLING_FREQUENCY' | translate" [sortable]="false">
            <ng-template ngx-datatable-cell-template let-row="row">
              {{ row.billing_frequency.name }}
            </ng-template>
          </ngx-datatable-column>
          <ngx-datatable-column [name]="'COMMISSION_DETAILS' | translate" width="90" [sortable]="false">
            <ng-template ngx-datatable-cell-template let-row="row">
              <div class="d-flex">
                <ng-container *ngIf="row.detachment_type!==null; else notDetachment">
                  <span class="mr-075" *ngIf="row.commission_type.toString() === 'time_material' && row.detachment_type === 'distacco'" [ngbTooltip]="'DETACHMENT_TIME_MATERIAL' | translate">
                    <i [data-feather]="'repeat'" size="19"></i>
                  </span>
                  <span class="mr-075" *ngIf="row.commission_type.toString() === 'task' && row.detachment_type === 'distacco'" [ngbTooltip]="'DETACHMENT_TASK' | translate">
                    <i [data-feather]="'repeat'" size="19"></i>
                  </span>
                  <span class="mr-075" *ngIf="row.commission_type.toString() === 'time_material' && row.detachment_type === 'delta'" [ngbTooltip]="'DELTA_TIME_MATERIAL' | translate">
                    <i [data-feather]="'repeat'" size="19"></i>
                  </span>
                  <span class="mr-075" *ngIf="row.commission_type.toString() === 'task' && row.detachment_type === 'delta'" [ngbTooltip]="'DELTA_TASK' | translate">
                    <i [data-feather]="'repeat'" size="19"></i>
                  </span>
                </ng-container>
                <ng-template #notDetachment>
                  <span class="mr-075" *ngIf="row.commission_type.toString() === 'time_material'" [ngbTooltip]="'TIME_MATERIAL' | translate">
                    <i [data-feather]="'clock'" size="19"></i>
                  </span>
                  <span class="mr-075" *ngIf="row.commission_type.toString() === 'task'" [ngbTooltip]="'TASK' | translate">
                    <i [data-feather]="'calendar'" size="19"></i>
                  </span>
                </ng-template>
                <span class="mr-075" *ngIf="row.users_names?.length > 1" [ngbTooltip]="row.users_names?.join(', ')">
                  <i [data-feather]="'users'" size="19"></i>
                </span>
                <span class="mr-075" *ngIf="row.users_names?.length == 1" [ngbTooltip]="row.users_names[0]">
                  <i [data-feather]="'user'" size="19"></i>
                </span>
                <span class="mr-075" *ngIf="row.products_names?.length > 0" [ngbTooltip]="row.products_names?.join(', ')">
                  <i [data-feather]="'package'" size="19"></i>
                </span>
              </div>
            </ng-template>
          </ngx-datatable-column>
          <ngx-datatable-column [name]="'ESTIMATED_REVENUE' | translate" prop="estimate_profit" width="90" [sortable]="true">
            <ng-template ngx-datatable-cell-template let-row="row">
              <span>{{ row.estimate_profit | currency: "EUR" }}</span>
            </ng-template>
          </ngx-datatable-column>
          <ngx-datatable-column [name]="'ACTIONS' | translate" width="40" [sortable]="false">
            <ng-template ngx-datatable-cell-template let-row="row">
              <div class="d-flex">
                <button has_capability="archive_invoice" [ngbTooltip]="'RESTORE' | translate" (click)="unarchiveInvoice(row)" type="button" class="bg-transparent border-0">
                  <i class="text-warning" [data-feather]="'archive'" size="19"></i>
                </button>
              </div>
            </ng-template>
          </ngx-datatable-column>
        </ngx-datatable>
      </div>
    </div>
  </div>
</div>